import { Col, Row } from 'antd';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import WorkOrderRowDisplay from '../work_order_row_display/WorkOrderRowDisplay';

require('./WorkOrderTableRowWithoutActions.less');

const WorkOrderTableRowWithoutActions = ({
	record,
	location,
	backText,
	targetCollectionName,
	userType,
}) => {
	const BACK_TEXT = backText || 'Back to work orders';

	const getLink = useCallback(() => {
		const path = `/${userType}/workOrders/detail/${nullSafeGet('id', record)}/details${
			targetCollectionName ? `?targetCollectionName=${targetCollectionName}` : ''
		}`;
		return getLinkWIthBackLinkParams(location, BACK_TEXT, path, {
			preserve: true,
		});
	}, [BACK_TEXT, location, record, targetCollectionName, userType]);

	return (
		<Row className="index-row-wrapper" style={{ display: 'flex', flexWrap: 'nowrap' }}>
			<Col style={{ display: 'flex', flexGrow: 1 }}>
				<Link className="index-padding" style={{ width: '100%' }} to={getLink()}>
					<WorkOrderRowDisplay workOrder={record} />
				</Link>
			</Col>
		</Row>
	);
};

export default withRouter(
	connect(
		(state) => ({
			userType: (state as any).session.userType,
		}),
		() => ({})
	)(WorkOrderTableRowWithoutActions)
);
